/**
 * ルート遷移時にページ先頭へスクロールするユーティリティ。
 *
 * React Router はデフォルトで遷移時のスクロール位置を引き継ぐため、
 * 縦に長いページから別ページへ移ると前ページの座標を引きずってしまう。
 * これを防ぐため、PUSH/REPLACE 遷移 (リンククリック・navigate) のときだけ
 * 先頭へ戻す。戻る/進む (POP) のときはブラウザのスクロール位置復元に任せる。
 *
 * pathname の変化のみを契機にする (search の変化では発火しない) ため、
 * クエリパラメータのクリーンアップ (?express=1 の除去等) では誤発火しない。
 */

import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

export function ScrollToTop() {
  const { pathname, state } = useLocation();
  const navigationType = useNavigationType();
  const preserveScroll = (state as { preserveScroll?: boolean } | null)?.preserveScroll === true;

  useEffect(() => {
    if (navigationType === 'POP') return;
    // 同一画面内のタブ切り替え等、明示的にスクロール維持を指示された遷移は除外
    if (preserveScroll) return;
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname, navigationType, preserveScroll]);

  return null;
}
